import { COOKIE_CATEGORY } from 'common/constants/cookieManagement';

/**
 * Registry of all cookies dropped in the Guest facing Pages.
 * Grouping by cookie category is required to comply with GDPR.
 */
export const Cookies = Object.freeze({
    [COOKIE_CATEGORY.NECESSARY]: [
        'splash_anonymous_id',
        'datadome',
        '_dd_s',
        'devspl',
        'CakeCookie[current_tracking_link___ID__]',
        'CakeCookie[TrackingLink]__ID__',
        'CakeCookie[age_year]',
        'CakeCookie[age_month]',
        'CakeCookie[age_day]',
        'CakeCookie[age_country]',
        '__ID__hubbypass',
        'wlv',
        'spladzooks',
        'tuningfork',
        'gateBypass___ID__',
    ],
    [COOKIE_CATEGORY.PERFORMANCE]: [
        '_ga',
        '_ga___ID__',
        '_gid',
        'rsvpTotal-__ID__',
        'ticketTotal-__ID__',
        '__gtm_campaign_url',
        'fs_lua',
        'fs_uid',
        '_hp2_id',
        '_hp2_ses_props',
        '_hp2_props',
        '_zitok',
    ],
    [COOKIE_CATEGORY.FUNCTIONALITY]: ['mobileCheckinSortingMethod', '__stripe_mid', 'iter_id'],
    [COOKIE_CATEGORY.MARKETING]: ['_mkto_trk', 'bcookie', 'li_sugr', 'lidc', 'fr', '_fbp', '_fbc', 'fbs___ID__'],
});
